import { createPortal } from "react-dom";

export default function AddQuestionModal({
  open,
  steps = [],
  selectedStep,
  questionText,
  saving,
  onStepChange,
  onChange,
  onClose,
  onConfirm,
}) {
  if (!open) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-gray-600/50 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="add-question-title"
    >
      <div className="relative p-4 w-full max-w-xl max-h-full">
        <div className="relative bg-white rounded-lg shadow">
          <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t">
            <h3 id="add-question-title" className="text-xl font-semibold text-gray-900">
              Add Question
            </h3>
            <button
              type="button"
              className="text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-lg text-2xl leading-none w-10 h-10 inline-flex justify-center items-center"
              onClick={onClose}
              aria-label="Close"
            >
              ×
            </button>
          </div>

          <div className="p-4 md:p-5 space-y-4">
            {steps.length > 0 && (
              <div>
                <label className="block text-sm font-bold text-[#004F73] mb-1">
                  Section <span className="text-red-500">*</span>
                </label>
                <select
                  value={selectedStep}
                  onChange={(e) => onStepChange(Number(e.target.value))}
                  className="bg-gray-50 border border-gray-300 text-sm rounded-lg w-full p-2.5"
                >
                  {steps.map((s, i) => (
                    <option key={s.step ?? i + 1} value={s.step ?? i + 1}>
                      {s.title || `Section ${s.step ?? i + 1}`}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div>
              <label className="block text-sm font-bold text-[#004F73] mb-1">
                Question Text <span className="text-red-500">*</span>
              </label>
              <textarea
                value={questionText}
                onChange={(e) => onChange(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-sm rounded-lg w-full p-2.5 resize-none"
                placeholder="Type the question here..."
                rows={3}
                required
              />
            </div>

            <p className="text-xs text-gray-500">
              A standard importance + agreement MCQ question will be created. You can edit the text afterwards.
            </p>

            <div className="flex items-center justify-center gap-4 pt-2">
              <button
                type="button"
                className="px-6 py-2 rounded-full border border-gray-300 text-gray-700 font-medium hover:bg-gray-50"
                onClick={onClose}
                disabled={saving}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={onConfirm}
                disabled={saving || !questionText.trim()}
                className="px-6 py-2 rounded-full font-medium text-white bg-[#004F73] hover:opacity-90 disabled:opacity-50"
              >
                {saving ? "Adding…" : "Add Question"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
